import React from 'react';
import {TFunction} from 'react-i18next';
import {EntityListColumn} from 'components';
import {useUserContext} from 'authentication/UserContext';
import {getRegulatoryDocumentsListBaseColumns} from '../RegulatoryDocumentsListBaseColumns';

type UseRegulatoryDocumentsListColumnsParams = {
	t: TFunction;
	tEnum: TFunction;
	tPogis: TFunction;
	showWorkflowStatus?: boolean;
};

const hiddenForAvk = new Set<string>([
	'rd-pogis',
	'p-dateNewRegistration',
	'p-dateNewTypes',
	'p-dateEffective',
	'rd-modelYear',
	'rd-phaseIn',
	'rd-phaseOut',
]);

export const useRegulatoryDocumentsListColumns = ({
	t,
	tEnum,
	tPogis,
	showWorkflowStatus = false,
}: UseRegulatoryDocumentsListColumnsParams): EntityListColumn[] => {
	const {isAvk, isBav} = useUserContext();
	const isAvkOrBav = isAvk || isBav;

	const baseColumns = React.useMemo(
		() =>
			getRegulatoryDocumentsListBaseColumns(
				t,
				tEnum,
				tPogis,
				showWorkflowStatus,
			),
		[t, tEnum, tPogis, showWorkflowStatus],
	);

	return React.useMemo(() => {
		if (!isAvkOrBav) return baseColumns;
		return baseColumns.filter(col => !hiddenForAvk.has(col.key ?? ''));
	}, [baseColumns, isAvkOrBav]);
};
